<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
    <CustomerServiceIcon v-if="isLoggedIn" />
  </div>
</template>

<script>
import baseUrls from "@/api/baseUrls";
import { EventBus } from "@/store/event-bus";
import { getToken } from "@/utils/auth";
import CustomerServiceIcon from "@/components/CustomerServiceIcon.vue";

export default {
  name: "App",
  components: {
    CustomerServiceIcon,
  },
  data() {
    return {
      socket: null,
      intervalId: "",
      userId: null,
    };
  },
  computed: {
    // 判断是否已登录
    isLoggedIn() {
      // 检查 token 和用户信息
      const token = getToken();
      const user = this.$store.state.user["user"];
      return !!(token && user);
    },
  },
  mounted() {
    let user = this.$store.state.user["user"];
    if (user) {
      this.userId = user.userId;
      this.init();
    }
    let _this = this;
    this.intervalId = setInterval(function () {
      if (_this.socket == null || _this.socket.readyState == 3) {
        let user = _this.$store.state.user["user"];
        if (user) {
          _this.userId = user.userId;
          _this.init();
        }
      } else {
        if (_this.socket.readyState === WebSocket.OPEN) {
          _this.socket.send("heart beat");
        } else {
          // console.error("WebSocket is not open. ReadyState:", _this.socket.readyState);
          let user = _this.$store.state.user["user"];
          if (user) {
            _this.userId = user.userId;
            _this.init();
          }
        }
      }
    }, 10000);
  },

  methods: {
    // 初始化方法
    init() {
      //console.log("初始化");
      //1、websocket接口的url
      let ws = `${baseUrls.ws}/platformAsync/${this.userId}`;
      // 实例化socket
      this.socket = new WebSocket(ws);
      // 监听socket连接
      this.socket.onopen = this.socketopen;
      // 监听socket错误信息
      this.socket.onerror = this.error;
      // 监听socket消息
      this.socket.onmessage = this.getMessage;
      // 监听socket断开连接的消息
      this.socket.close = this.close;
    },
    // 连接成功方法
    socketopen() {
      //console.log("socket连接成功");
    },
    // 连接错误
    error() {
      // console.log("连接错误");
    },
    // 接受信息接口
    getMessage(message) {
      // console.log("收到消息");
      if (message.data === "heart beat") {
        return;
      }
      //当接受到信息之后，就可以做后续的处理了
      // let data = JSON.parse(message.data);
      let json = JSON.parse(message.data);
      if (json.type === "rideArrive") {
        this.$notify({
          title: "消息通知",
          type: "success",
          message: json.data,
          position: "bottom-left",
          customClass: "wd260",
          onClick: this.handleToOrder(json.orderId),
          duration: 60000,
        });
      } else if (json.type === "info") {
        this.$alert(json.data, "消息提醒");
      }
      EventBus.$emit("refreshPage", message.data);
    },
    handleToOrder(orderId) {
      let _this = this;
      return function() {
        _this.$router.push({ path: "/order/orderInquiry", query: { orderId } });
      }
    },
    // 关闭处理
    close() {
      // console.log("连接关闭");
    },
  },
};
</script>

<style lang="scss">
.wd260 {
  width: 260px !important;
}

.notifyButton {
  padding: 5px 30px;
  background-color: #3498db; /* 设置背景颜色为蓝色 */
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  border-radius: 5px;
}

.notifyTitle {
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 5px;
  color: rgb(245, 154, 35);
}

.notifyContent {
  margin-bottom: 10px;
}
</style>
